var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clock icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0431\\u0438\\u043B\\u0435\\u0442\\u044B-\\u043D\\u043E\\u0432\\u043E\\u0435",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0416\\u0434+\\u0430\\u0432\\u0438\\u0430-\\u0432\\u044B\\u0431\\u043E\\u0440-\\u0442\\u0430\\u0440\\u0438\\u0444\\u0430-\\u0430\\u0432\\u0438\\u0430",
    transform: "translate(-1261.000000, -938.000000)",
    fill: "#C99478",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock-icon",
    transform: "translate(1261.000000, 938.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.7077757 1.23191948 3.68299065 1.74971149e-13 0.0184299065 3.10395399 1.04325234 4.33587347"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "15.9722617 3.10799245 12.3077009 0.00403846154 11.2829159 1.23595794 14.9474766 4.33991193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99134579,1.72306434 C11.9589346,1.72306434 15.1729159,4.96791157 15.1729159,8.96964953 C15.1729159,12.9713875 11.9589346,16.2162347 7.99134579,16.2162347 C4.02375701,16.2162347 0.817775701,12.9713875 0.817775701,8.96964953 C0.817775701,4.96791157 4.02375701,1.72306434 7.99134579,1.72306434 Z M8.39407477,4.94379403 L7.19781308,4.94379403 L7.19781308,9.77485083 L10.982,12.0736035 L11.5841308,11.0792362 L8.39407477,9.17096873 L8.39407477,4.94379403 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.72a553c9becac307069ae31a144dee87.svg";
export { ForwardRef as ReactComponent };